import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "trash",
  "use": "trash-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"trash\"><path d=\"M5 3V1.01C5 .442 5.444 0 5.99 0h4.02c.54 0 .99.452.99 1.01V3h4c.555 0 1 .447 1 1v2h-2v7.997c0 1.11-.9 2.003-2.01 2.003H4.01C2.9 16 2 15.103 2 13.997V6H0V4c0-.557.448-1 1-1zm-.003 2A.997.997 0 0 0 4 5.998v7.004c0 .55.453.998.997.998h6.006c.55 0 .997-.446.997-.998V5.998c0-.55-.453-.998-.997-.998zM7 2v1h2V2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol